import { get_cdn_url, use_store } from "../store";

interface TableRow {
  feature: string;
  icon: string;
  lulu_loyal: string;
  lulu_loyal_check: boolean;
  everyone_else: string;
  everyone_else_check: boolean;
}

export default function MarketingTable() {
  const { t } = use_store();

  const table_data: TableRow[] = [
    {
      feature: t("Anonymity"),
      icon: "🤫",
      lulu_loyal: t("Secure + Untraceable"),
      lulu_loyal_check: true,
      everyone_else: t("Security Risks"),
      everyone_else_check: false,
    },
    {
      feature: t("Pricing"),
      icon: "💸",
      lulu_loyal: t("Lowest Prices"),
      lulu_loyal_check: true,
      everyone_else: t("Pretends to Be Free"),
      everyone_else_check: false,
    },
    {
      feature: t("Speed"),
      icon: "✈️",
      lulu_loyal: t("Fastest + Best Results"),
      lulu_loyal_check: true,
      everyone_else: t("Slow + Poor Results"),
      everyone_else_check: false,
    },
    {
      feature: t("Quality"),
      icon: "🛍️",
      lulu_loyal: t("Unmatched Accuracy"),
      lulu_loyal_check: true,
      everyone_else: t("Consistent Errors"),
      everyone_else_check: false,
    },
    {
      feature: t("Features"),
      icon: "💪",
      lulu_loyal: t("Best Features"),
      lulu_loyal_check: true,
      everyone_else: t("Limited Features"),
      everyone_else_check: false,
    },
    {
      feature: t("Support"),
      icon: "📱",
      lulu_loyal: t("Insta, TikTok, Snap, Reddit and more"),
      lulu_loyal_check: true,
      everyone_else: t("Only Instagram"),
      everyone_else_check: false,
    },
  ];
  return (
    <div className="w-full max-w-[900px]">
      <p className="stitle mb-[32px]">{t("Why Lulu Loyal?")}</p>
      <div className="">
        <div className="flex">
          <div className="w-[180px] max-w-[180px] p-[24px] bg-transparent"></div>
          <div className="flex-1 px-[0px] py-[24px] border-l-[1px] border-r-[1px] border-t-[1px] border-l-brand-2 border-r-brand-2 border-t-brand-2 rounded-tl-[4px] rounded-tr-[4px] lg:rounded-tr-none flex items-center justify-center py-[40px] bg-surface">
            <img
              src={get_cdn_url("/favicon_2.webp")}
              alt="Lulu Loyal"
              className="h-[48px] mr-[8px]"
            />
            <span className="vsmallt_med">{t("Lulu Loyal")}</span>
          </div>
          <div className="flex-1 p-[24px] border-[1px] border-lines flex items-end justify-center rounded-tr-[4px] h-[60px] mt-[80px] bg-surface hidden lg:flex">
            <span className="vsmallt_med">{t("Everyone Else")}</span>
          </div>
        </div>
        {table_data.map((row, index) => (
          <div key={index} className="flex">
            <div
              className={`w-[180px] max-w-[180px] bg-surface p-[24px] border-l-[1px] border-lines flex items-center border-b-[1px]  max-h-[106px] ${index == 0 ? "border-t-[1px]" : ""}`}
            >
              <span className="text-[20px] mr-[12px]">{row.icon}</span>
              <span className="vsmallt_med">{row.feature}</span>
            </div>
            <div
              className={`flex-1 bg-surface border-l-[1px] border-r-[1px] border-l-brand-2 border-r-brand-2 flex items-center ${index === table_data.length - 1 ? "border-b-[1px] border-b-brand-2 rounded-bl-[4px] rounded-br-[4px] pt-[6px] pb-[70px] flex items-center" : ""}`}
            >
              <div
                className={`${index < table_data.length - 1 && "border-b-[1px] border-b-brand-2"} py-[24px] px-[20px] w-full  ${index == 0 ? "border-t-brand-2 border-t-[1px]" : ""}`}
              >
                <span className="text-[20px] mr-[12px]">
                  {row.lulu_loyal_check ? "✅" : "❌"}
                </span>
                <span className="vsmallt_med">{row.lulu_loyal}</span>
              </div>
            </div>
            <div className="flex-1 bg-surface p-[24px] border-b-[1px] border-lines flex items-center border-r-[1px] max-h-[106px] hidden lg:flex">
              <span className="text-[20px] mr-[12px]">
                {row.everyone_else_check ? "✅" : "❌"}
              </span>
              <span className="vsmallt_med">{row.everyone_else}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
